export enum LearningReviewSortStyle {
  named,
  termsCount,
  termsCountReverse,
  incorrectTermsCount,
}
